var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Enroll"},[_c('fp_header'),(_vm.user.enrolled)?_c('div',{staticClass:"spanel"},[_c('enrolled')],1):_c('div',{staticClass:"panel"},[_c('p_area'),_c('p_group'),_c('p_lang'),_c('p_invite'),_c('p_info')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }